import { render } from "./FormMini.vue?vue&type=template&id=6f3ef4f4"
import script from "./FormMini.vue?vue&type=script&lang=js"
export * from "./FormMini.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__